import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api/client';

/** A feature's default for every member without their own setting (admin-api /feature-flags). */
export interface FeatureFlag {
  featureKey: string;
  name: string;
  description: string | null;
  defaultEnabled: boolean;
  updatedAt: string | null;
  /** Members switched on one by one: they keep it whatever the default. */
  usersOn: number;
  /** Members switched off one by one: they stay off whatever the default. */
  usersOff: number;
}

export function useFeatureFlags() {
  return useQuery({
    queryKey: ['feature-flags'],
    queryFn: () => apiClient<FeatureFlag[]>('/feature-flags'),
  });
}

export function useSetFeatureDefault() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ featureKey, defaultEnabled }: { featureKey: string; defaultEnabled: boolean }) =>
      apiClient<FeatureFlag & { message: string }>(`/feature-flags/${encodeURIComponent(featureKey)}`, {
        method: 'PUT',
        body: JSON.stringify({ defaultEnabled }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['feature-flags'] }),
  });
}
